import { z } from "zod";

import { env } from "@/env";

export const axiosErrorSchema = z.object({
  response: z.object({
    data: z.object({
      status: z.number(),
      success: z.boolean(),
      error: z.object({
        code: z.string(),
        message: z.string(),
        fields: z.record(z.string(), z.array(z.string())).optional(),
      }),
    }),
  }),
});

export type AxiosValidationError = z.infer<typeof axiosErrorSchema>;

export const validateError = (data: unknown): AxiosValidationError | undefined => {
  const parsed = axiosErrorSchema.safeParse(data);

  return parsed.success ? parsed.data : undefined;
};

export const getPostPurchaseUrlSignature = (url: string) => {
  const { pathname, search } = new URL(`${env.VITE_API_URL}${url}`);

  return btoa(`${env.VITE_POST_PURCHASE_SIGNATURE}.` + btoa(`${pathname}${search}`));
};

export const isExternalLink = (href: string): boolean => {
  try {
    const url = new URL(href, window.location.origin);

    return url.origin !== window.location.origin;
  } catch {
    return false;
  }
};
